import {corppassLogin as getCorppassLoginURL} from '@ntprsrf-frontend/service/src/services/intranet/auth.service';
import type {Router} from "vue-router";

export const corppassLogin = async (pathToSave: string) => {
    try {
        localStorage.setItem("redirect", JSON.stringify({
            path: pathToSave || '/'
        }));
        window.location.href = getCorppassLoginURL();
    } catch (e) {
        console.error("ERROR HERE", pathToSave, e);
    }
}

export const redirectProcess = (router: Router) => {
    const redirectString = localStorage.getItem("redirect")
    if (redirectString) {
        try {
            const redirectPage = JSON.parse(redirectString)
            const r = /^(?:[a-z+]+:)?\/\//i;
            if (r.test(redirectPage.path)) { // if true then it is an absolute path
                window.location.href = redirectPage.path;
            } else {
                router.push(redirectPage);
            }
        } catch { // catch if string is not a JSON
            router.push({
                name: "HOME"
            })
        }
    } else {
        router.push({
            name: "HOME"
        })
    }
}